<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2025 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<scrm-modal *ngIf="modalStore"
            [closable]="true"
            [close]="closeButton"
            [titleKey]="titleKey"
            [descriptionKey]="descriptionKey"
            [dynamicTitleKey]="dynamicTitleKey"
            [dynamicTitleContext]="context"
            [dynamicTitleFields]="fields"
            [dynamicDescriptionKey]="dynamicDescriptionKey"
            [dynamicDescriptionFields]="fields"
            [dynamicDescriptionContext]="context"
            [minimizable]="minimizable"
            (onMinimizeToggle)="onMinimizeToggle($event)"
            bodyKlass="m-0 p-0 small-font scrollbar-thin {{bodyClass}}"
            footerKlass="border-0 {{footerClass}}"
            headerKlass="border-bottom {{headerClass}} "
            klass="record-modal rounded {{wrapperClass}}">
    <div modal-body>

        <ng-container *ngIf="!isMinimized()">
            <div *ngIf="record">
                <scrm-record-content [dataSource]="contentAdapter"></scrm-record-content>
            </div>

            <ng-container *ngIf="(loading$ | async) as loading">
                <scrm-loading-spinner *ngIf="loading" [overlay]="true"></scrm-loading-spinner>
            </ng-container>
        </ng-container>

    </div>
    <div modal-footer>
        <div *ngIf="record && modalStore" class="h-100 d-flex justify-content-end">
            <scrm-action-group-menu
                    [config]="actionsAdapter"
                    [actionContext]="viewContext"
                    buttonClass="settings-button"
                    [isRunning]="validating"
            >
            </scrm-action-group-menu>
        </div>
    </div>
</scrm-modal>
